import { resolveRgbString } from "./UploadedConversationsVisualizerDotField"
import { type RgbColor } from "./uploadedConversationsVisualizerParticles"

const ANOMALY_HIGHLIGHT_RADIUS = (0.58 * 1.75).toFixed(3)
const ANOMALY_HIGHLIGHT_STROKE_WIDTH = (0.44 * 1.75).toFixed(3)

interface SyncOverlayDotElementsParams {
  borderColor: RgbColor
  hasConversationHighlightFilter: boolean
  hitDot: SVGCircleElement | undefined
  isHighlightedConversation: boolean
  projected: { x: number; y: number }
  visibleDot: SVGCircleElement | undefined
}

export function syncOverlayDotElements({
  borderColor,
  hasConversationHighlightFilter,
  hitDot,
  isHighlightedConversation,
  projected,
  visibleDot,
}: SyncOverlayDotElementsParams) {
  if (visibleDot) {
    const isDeemphasizedConversation =
      hasConversationHighlightFilter && !isHighlightedConversation
    visibleDot.setAttribute("cx", projected.x.toFixed(3))
    visibleDot.setAttribute("cy", projected.y.toFixed(3))
    visibleDot.setAttribute(
      "r",
      isHighlightedConversation ? ANOMALY_HIGHLIGHT_RADIUS : "0.58",
    )
    visibleDot.setAttribute(
      "fill-opacity",
      isDeemphasizedConversation ? "0.62" : "1",
    )
    visibleDot.setAttribute(
      "data-conversation-highlighted",
      isHighlightedConversation ? "true" : "false",
    )
    visibleDot.setAttribute("stroke", resolveRgbString(borderColor))
    visibleDot.setAttribute(
      "stroke-opacity",
      isDeemphasizedConversation ? "0.55" : "1",
    )
    visibleDot.setAttribute(
      "stroke-width",
      isHighlightedConversation ? ANOMALY_HIGHLIGHT_STROKE_WIDTH : "0.44",
    )
  }

  if (hitDot) {
    hitDot.setAttribute("cx", projected.x.toFixed(3))
    hitDot.setAttribute("cy", projected.y.toFixed(3))
  }
}
